import React from 'react';

function TermsOfService() {
  return (
    <div style={{ 
      backgroundColor: '#0a0e1a',
      minHeight: '100vh',
      padding: '60px'
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '40px' }}>
          <h1 style={{ 
            fontSize: '42px',
            fontWeight: '800',
            margin: '0 0 15px 0',
            color: '#ffffff',
            letterSpacing: '-0.5px'
          }}>
            Terms of Service
          </h1>
          <p style={{ 
            fontSize: '14px',
            color: '#64748b',
            margin: 0
          }}>
            Last Updated: February 20, 2026
          </p>
        </div>

        {/* Content */}
        <div style={{
          backgroundColor: '#1a1f2e',
          border: '1px solid #2d3748',
          borderRadius: '12px',
          padding: '40px',
          color: '#a0aec0',
          fontSize: '15px',
          lineHeight: '1.8'
        }}>
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>1. Agreement to Terms</h2>
            <p style={{ marginBottom: '15px' }}>
              These Terms of Service ("Terms") constitute a legally binding agreement between you and 
              Upperline Solutions LLC ("Upperline Bet," "we," "us," or "our") governing your access to 
              and use of upperlinebet.com (the "Service").
            </p>
            <p style={{ marginBottom: '15px' }}>
              By accessing or using the Service, you agree to be bound by these Terms. If you do not agree 
              to these Terms, you may not access or use the Service.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>2. Eligibility</h2>
            <p style={{ marginBottom: '15px' }}>
              You must be at least 18 years old to use this Service. By using the Service, you represent 
              and warrant that you are at least 18 years of age.
            </p>
            <p style={{ marginBottom: '15px' }}>
              You are responsible for ensuring that your use of the Service complies with all applicable 
              laws and regulations in your jurisdiction, including but not limited to gambling and sports 
              betting laws.
            </p>
            <p style={{ marginBottom: '15px'}}>
              The Service is not intended for use in jurisdictions where sports betting or the use of sports 
              betting analytics tools is prohibited by law. By using the Service, you represent that use of 
              the Service is lawful in your jurisdiction. It is your sole responsibility to understand your 
              local laws and observe them. We do not provide legal advice regarding the legality of sports 
              betting or sports betting analytics in your jurisdiction.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>3. Service Description</h2>
            <p style={{ marginBottom: '15px' }}>
              Upperline Bet provides sports betting analytics, including:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Arbitrage opportunity detection across multiple sportsbooks</li>
              <li>Positive expected value (EV) bet identification</li>
              <li>Promotional offer optimization and bonus bet conversion tools</li>
              <li>Betting calculators and bankroll management tools</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              <strong>The Service provides information and analytical tools only. We do not facilitate, 
              process, or engage in sports betting or gambling activities.</strong>
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>4. Subscription and Billing</h2>
            
            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>4.1 Free Trial</h3>
            <p style={{ marginBottom: '15px' }}>
              New users may be eligible for a 7-day free trial. A valid payment method is required to start your free 
              trial. You will not be charged during the trial period.
            </p>
            <p style={{ marginBottom: '15px' }}>
              AUTO-CHARGE AUTHORIZATION: By starting your free trial, you separately and expressly authorize 
              Upperline Solutions LLC to automatically charge your payment method the then-current monthly 
              subscription fee (currently $100/month) on the day your trial ends, unless you cancel before that date. 
              You will receive a reminder email at least 3 days before your trial ends with the exact charge date and 
              amount. You may cancel at any time through your account settings to avoid being charged.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>4.2 Subscription Fees</h3>
            <p style={{ marginBottom: '15px' }}>
              The Service is offered on a monthly subscription basis at the rate displayed during sign-up 
              (currently $100/month, subject to promotional discounts). Subscription fees are billed monthly 
              in advance and are non-refundable except as described in Section 4.4.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>4.3 Automatic Renewal</h3>
            <p style={{ marginBottom: '15px' }}>
              Your subscription will automatically renew each month unless you cancel before the next billing 
              date. You authorize us to charge your payment method on a recurring monthly basis until you cancel.
            </p>
            <p style={{ marginBottom: '15px' }}>
              You may cancel your subscription at any time using the Cancel Subscription button in your account 
              settings page, without needing to contact support. Cancellation confirmation will be sent to your 
              account email address.
            </p>
            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>4.4 Refund Policy</h3>
            <p style={{ marginBottom: '15px' }}>
              <strong>7-Day Money-Back Guarantee:</strong> You may request a full refund within 7 days of any 
              charge by contacting support@upperlinebet.com. After 7 days, all sales are final and no refunds 
              will be issued.
            </p>
            <p style={{ marginBottom: '15px' }}>
              Refund requests must include your account email and reason for the refund. Refunds are processed 
              within 5-10 business days.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>4.5 Cancellation</h3>
            <p style={{ marginBottom: '15px' }}>
              You may cancel your subscription at any time through your account settings or by contacting 
              support@upperlinebet.com. Cancellation takes effect at the end of your current billing period. 
              You will retain access to the Service until that date. No partial refunds are provided for 
              unused portions of your subscription period.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>4.6 Payment Processing</h3>
            <p style={{ marginBottom: '15px' }}>
              All payments are processed securely through Stripe. We do not store your credit card information. 
              By providing payment information, you authorize Stripe to charge your payment method in accordance 
              with these Terms.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>4.7 Price Changes</h3>
            <p style={{ marginBottom: '15px' }}>
              We reserve the right to change subscription prices at any time. Price changes will take effect 
              at the start of your next billing cycle after at least 30 days' notice. Your continued use of 
              the Service after a price change constitutes acceptance of the new price.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>5. Account Registration and Security</h2>
            <p style={{ marginBottom: '15px' }}>
              To access certain features, you must create an account. You agree to:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Provide accurate, current, and complete information</li>
              <li>Maintain and update your information to keep it accurate</li>
              <li>Maintain the security of your password and account</li>
              <li>Notify us immediately of any unauthorized use</li>
              <li>Be responsible for all activity under your account</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              <strong>One Account Per Person:</strong> Each person is limited to one account and one free 
              trial. Creating multiple accounts to abuse the free trial or for any other purpose is strictly 
              prohibited and may result in immediate account termination without refund.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>6. Acceptable Use</h2>
            <p style={{ marginBottom: '15px' }}>You agree NOT to:</p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Use the Service for any illegal purpose</li>
              <li>Share your account credentials with others</li>
              <li>Resell, redistribute, or commercially exploit the Service or data</li>
              <li>Use automated tools (bots, scrapers) to access the Service</li>
              <li>Attempt to reverse engineer, decompile, or discover source code</li>
              <li>Interfere with or disrupt the Service or servers</li>
              <li>Circumvent any access restrictions or security measures</li>
              <li>Use the Service to transmit malware, viruses, or harmful code</li>
              <li>Impersonate another person or entity</li>
              <li>Collect user information without permission</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>7. Disclaimers and Limitations</h2>
            
            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>7.1 No Guarantees</h3>
            <p style={{ marginBottom: '15px' }}>
              <strong>THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND.</strong> We make no 
              guarantees regarding:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Accuracy, completeness, or timeliness of data or odds</li>
              <li>Availability of arbitrage or positive EV opportunities</li>
              <li>Profitability of any betting strategy or recommendation</li>
              <li>Uninterrupted or error-free operation of the Service</li>
            </ul>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>7.2 Betting Disclaimer</h3>
            <p style={{ marginBottom: '15px' }}>
              <strong>SPORTS BETTING INVOLVES FINANCIAL RISK.</strong> You should only bet what you can afford 
              to lose. The Service provides analytical tools and information but does not guarantee profits or 
              winning outcomes. Past performance and historical data do not guarantee future results.
            </p>
            <p style={{ marginBottom: '15px' }}>
              Odds can change rapidly. Opportunities identified by our Service may no longer be available by 
              the time you place a bet. Sportsbooks may limit or ban accounts that consistently profit.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>7.3 Third-Party Sportsbooks</h3>
            <p style={{ marginBottom: '15px' }}>
              We are not affiliated with, endorsed by, or responsible for any sportsbook. Your betting
              activities with third-party sportsbooks are subject to their terms and conditions. We are not
              responsible for their actions, policies, or any losses you incur.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>7.4 Confidential Data</h3>
            <p style={{ marginBottom: '15px' }}>
              All data, odds, analytics, arbitrage opportunities, expected value calculations, and any other
              content accessible through your paid subscription (collectively, "Service Data") constitute the
              confidential and proprietary information of Upperline Solutions LLC. By accessing the Service,
              you agree to:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Treat all Service Data as confidential with at least the same care you would use to protect your own confidential information</li>
              <li>Not publish, share, screenshot, redistribute, or otherwise allow any person who is not a registered subscriber to access Service Data</li>
              <li>Not use Service Data for any commercial purpose other than your own personal betting activities</li>
              <li>Not use Service Data to build competing products, train machine learning models, or compile derivative databases</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              Violation of this section may result in immediate account termination without refund and may
              subject you to legal action.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>7.5 Legal Compliance</h3>
            <p style={{ marginBottom: '15px' }}>
              You are solely responsible for ensuring that your use of sports betting information complies 
              with all applicable laws in your jurisdiction. We do not provide legal advice regarding sports 
              betting legality.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>8. Limitation of Liability</h2>
            <p style={{ marginBottom: '15px' }}>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, UPPERLINE SOLUTIONS LLC SHALL NOT BE LIABLE FOR:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Any indirect, incidental, special, consequential, or punitive damages</li>
              <li>Loss of profits, revenue, data, or business opportunities</li>
              <li>Betting losses or financial damages of any kind</li>
              <li>Damages resulting from unauthorized access to your account</li>
              <li>Damages resulting from errors, interruptions, or delays in the Service</li>
              <li>Damages resulting from reliance on any information provided</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              OUR TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING FROM YOUR USE OF THE SERVICE SHALL NOT EXCEED THE 
              TOTAL AMOUNT YOU PAID US IN THE THREE (3) MONTHS IMMEDIATELY PRECEDING THE CLAIM.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>9. Indemnification</h2>
            <p style={{ marginBottom: '15px' }}>
              You agree to indemnify, defend, and hold harmless Upperline Solutions LLC and its officers, 
              directors, employees, and agents from any claims, liabilities, damages, losses, costs, or 
              expenses (including legal fees) arising from:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Your use of the Service</li>
              <li>Your betting activities</li>
              <li>Your violation of these Terms</li>
              <li>Your violation of any law or third-party rights</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>10. Intellectual Property</h2>
            <p style={{ marginBottom: '15px' }}>
              The Service, including all content, features, algorithms, data compilations, software, and 
              design, is owned by Upperline Solutions LLC and protected by copyright, trademark, and other 
              intellectual property laws.
            </p>
            <p style={{ marginBottom: '15px' }}>
              You are granted a limited, non-exclusive, non-transferable license to access and use the Service 
              for your personal, non-commercial use only. You may not copy, modify, distribute, sell, or 
              create derivative works from any part of the Service.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>11. Termination</h2>
            <p style={{ marginBottom: '15px' }}>
              We reserve the right to suspend or terminate your account at any time, with or without notice, 
              for any reason, including but not limited to:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Violation of these Terms</li>
              <li>Fraudulent or suspicious activity</li>
              <li>Abuse of the Service or free trial</li>
              <li>Non-payment of subscription fees</li>
              <li>Request by law enforcement or government agencies</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              Upon termination, your access to the Service will immediately cease. No refunds will be provided 
              for accounts terminated due to Terms violations.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>12. Modifications to Service and Terms</h2>
            <p style={{ marginBottom: '15px' }}>
              We reserve the right to modify, suspend, or discontinue the Service (or any part thereof) at 
              any time with or without notice. We will not be liable to you or any third party for any 
              modification, suspension, or discontinuation of the Service.
            </p>
            <p style={{ marginBottom: '15px' }}>
              We may modify these Terms at any time. We will provide notice of material changes via email or 
              through the Service at least 30 days before they take effect. Your continued use of the Service 
              after changes become effective constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>13. Dispute Resolution</h2>
            
            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>13.1 Governing Law</h3>
            <p style={{ marginBottom: '15px' }}>
              These Terms are governed by the laws of the Commonwealth of Massachusetts, without regard to 
              conflict of law principles.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>13.2 Informal Resolution</h3>
            <p style={{ marginBottom: '15px' }}>
              Before filing a claim, you agree to contact us at legal@upperlinebet.com to attempt to resolve 
              the dispute informally. We will attempt to resolve disputes in good faith within 60 days.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>13.3 Arbitration</h3>
            <p style={{ marginBottom: '15px' }}>
              Any dispute not resolved through informal resolution under Section 13.2 shall be finally resolved 
              by binding arbitration administered by the American Arbitration Association (AAA) under its Consumer 
              Arbitration Rules, which are available at adr.org. The arbitration will take place in Boston, 
              Massachusetts, or by telephone/videoconference at the election of the party initiating the claim. 
              The arbitrator's decision will be final and binding and may be entered as a judgment in any court 
              of competent jurisdiction.
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong>Small Claims Exception:</strong> Either party may bring an individual claim in small claims 
              court as an alternative to arbitration, provided the claim qualifies under that court's jurisdictional 
              limits.
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong>Arbitration Costs:</strong> For claims you initiate, you are responsible for your share of AAA filing fees as 
              set by AAA rules. For claims we initiate, we will pay all AAA filing fees. For any claim under $10,000 
              that you bring and win, we will reimburse your reasonable AAA filing fees.
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong>Class Action Waiver:</strong> You agree to bring claims against Upperline Solutions LLC only in your individual 
              capacity and not as part of any class action, collective action, representative proceeding, or private 
              attorney general action. The arbitrator may not consolidate more than one person's claims.
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong>Opt-Out Right:</strong> You may opt out of this arbitration agreement by sending written notice to 
              legal@upperlinebet.com within 30 days of first creating your account. Your notice must include your 
              name, account email, and a statement that you are opting out of arbitration. If you opt out, disputes 
              will be resolved in courts located in Boston, Massachusetts.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>13.4 Force Majeure</h3>
            <p style={{ marginBottom: '15px' }}>
              Upperline Solutions LLC shall not be liable for any failure or delay in performance of the Service 
              resulting from causes beyond our reasonable control, including but not limited to: data provider outages 
              or policy changes, sportsbook API modifications or terminations, internet or telecommunications failures, 
              cyberattacks or security incidents affecting third-party infrastructure, natural disasters, acts of 
              government, or actions of third parties outside our control. In such events, our obligations will be 
              suspended for the duration of the cause, and we will use commercially reasonable efforts to resume 
              service as quickly as practicable.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>13.5 Affiliate Relationships</h3>
            <p style={{ marginBottom: '15px' }}>
              We may in the future earn referral commissions if you sign up for third-party sportsbooks or services 
              through links on our platform. Any such affiliate relationships will be clearly disclosed near the 
              relevant links. These relationships do not affect the independence or integrity of our data, analytics, 
              or recommendations. We will update this section and our Privacy Policy when any affiliate relationships 
              are established.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>14. Miscellaneous</h2>
            
            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>14.1 Entire Agreement</h3>
            <p style={{ marginBottom: '15px' }}>
              These Terms, together with our Privacy Policy, constitute the entire agreement between you and 
              Upperline Solutions LLC regarding the Service.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>14.2 Severability</h3>
            <p style={{ marginBottom: '15px' }}>
              If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions 
              will remain in full force and effect.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>14.3 Waiver</h3>
            <p style={{ marginBottom: '15px' }}>
              Our failure to enforce any right or provision of these Terms will not constitute a waiver of 
              such right or provision.
            </p>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>14.4 Assignment</h3>
            <p style={{ marginBottom: '15px' }}>
              You may not assign or transfer these Terms or your account without our written consent. We may 
              assign these Terms without restriction.
            </p>
          </section>

          <section>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>15. Contact Information</h2>
            <p style={{ marginBottom: '15px' }}>
              Questions about these Terms should be directed to:
            </p>
            <p style={{ marginBottom: '5px' }}>
              Upperline Solutions LLC<br />
              Boston, MA<br />
              Email: legal@upperlinebet.com<br />
              Support: support@upperlinebet.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;